import { render, staticRenderFns } from "./tinymceEditor.vue?vue&type=template&id=11057970"
import script from "./tinymceEditor.vue?vue&type=script&lang=js"
export * from "./tinymceEditor.vue?vue&type=script&lang=js"
import style0 from "./tinymceEditor.vue?vue&type=style&index=0&id=11057970&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports